import { db } from "../config/firebase-init";

export default db;
